import { ErrorHandler, Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthStateService } from '../auth/auth-state.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService implements ErrorHandler {
  private readonly authState = inject(AuthStateService);

  handleError(error: unknown): void {
    console.error(error);

    if (
      error instanceof HttpErrorResponse &&
      error.status === 401 &&
      error.url != null &&
      !error.url.includes('user/session')
    ) {
      this.redirectToLoginPage();
      return;
    }

    const message = this.extractMessage(error);
    if (message) {
      console.warn('Unhandled error:', message);
    }
  }

  private redirectToLoginPage(): void {
    this.authState.clearSession();
    const confirmed = window.confirm(
      'Your session has timed out. Click OK to relaunch the application from the portal.',
    );
    if (confirmed) {
      window.location.href = `${environment.portalSiteUrl}login`;
    }
  }

  private extractMessage(error: unknown): string | undefined {
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) return 'Server unavailable';
      if (error.status === 502) return 'Backend services unavailable';
      if (error.status === 504) return 'Backend services took too long to respond';
      const body = error.error as { message?: string; Message?: string } | string | null;
      if (typeof body === 'string') return body;
      return body?.message ?? body?.Message;
    }
    if (error instanceof Error) return error.message;
    return undefined;
  }
}
